// SPDX-License-Identifier: GPL-3.0-or-later
// Loader of the SigmaBots table. The JSON file is the one source of table data.
// The editor (B6) writes it. This loader validates it and returns a TableSpec.
// No import of three or DOM.

import type { TableSpec } from "../shared/contracts.ts";
import raw from "./data/vibe-01.table.json";
import { ITEM, LIGHT } from "./ids.ts";
import { validateTable } from "./validate.ts";

/** Names that the rules need in the table data (every item and light that the rules read or set). */
export const RULE_REQUIRED_NAMES: readonly string[] = [
  ...Object.entries(ITEM)
    // Tilt is an input event, not an item.
    .filter(([key]) => key !== "tilt")
    .map(([, name]) => name),
  ...Object.values(LIGHT),
];

/** Load and check the table. Throw an Error with the list of problems when the data is not valid. */
export function loadVibe01Table(): TableSpec {
  const result = validateTable(raw, { requireNames: RULE_REQUIRED_NAMES });
  if (!result.ok) {
    throw new Error(`vibe-01.table.json is not valid:\n${result.errors.join("\n")}`);
  }
  return result.table;
}
